import { motion } from "framer-motion";
import { Sparkles, Trophy, ShieldCheck, ArrowUpRight } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const levers = [
  {
    icon: Sparkles,
    label: "Aspiration",
    body: "We help your brand speak to the future your learners are trying to build, not just the program you are trying to sell.",
  },
  {
    icon: Trophy,
    label: "Achievement",
    body: "We help you show clear outcomes, practical value, and the real progress learners can expect from choosing you.",
  },
  {
    icon: ShieldCheck,
    label: "Assurance",
    body: "We help you build the trust, credibility, and clarity learners need before they commit their time, money, and future to your brand.",
  },
];

export const Levers = () => {  return (
    <section className="bg-[#FAF7F2] text-[#1A2238] py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Left: content */}
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport}>
          <motion.p variants={fadeUp} className="eyebrow text-[#FF6A3D] mb-6">
            Learner Decision Levers
          </motion.p>
          <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.05]">
            We Activate Levers Learners Look For
          </motion.h2>

          <div className="mt-10 space-y-6">
            {levers.map((l) => {
              const Icon = l.icon;
              return (
                <motion.div
                  variants={fadeUp}
                  key={l.label}
                  data-testid={`lever-${l.label.toLowerCase()}`}
                  className="flex gap-4"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#FF6A3D]">
                    <Icon size={20} className="text-[#1A2238]" />
                  </span>
                  <div>
                    <h3 className="font-display text-xl font-bold tracking-tight">{l.label}</h3>
                    <p className="mt-1.5 text-[15px] text-[#1A2238]/65 leading-relaxed max-w-lg">{l.body}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>

          <motion.a
            variants={fadeUp}
            href="https://cal.com/raj-rakshit-ssudkn"
            data-testid="levers-cta"
            className="group mt-10 inline-flex items-center gap-3 bg-[#FF6A3D] text-[#FAF7F2] font-bold text-base py-2 pl-7 pr-2 rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_36px_rgba(255,106,61,0.4)]"
          >
            Unlock Your Growth
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1A2238] text-[#FAF7F2] transition-transform duration-300 group-hover:rotate-45">
              <ArrowUpRight size={18} />
            </span>
          </motion.a>
        </motion.div>

        {/* Right: circular learner portrait with squiggle accents */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="relative flex justify-center"
        >
          <div className="relative w-[340px] h-[440px] sm:w-[400px]">
            {/* half arc */}
            <div className="absolute bottom-0 inset-x-0 h-[320px] rounded-t-full bg-[#FF6A3D]/15 border-t-2 border-x-2 border-[#FF6A3D]/30" />
            {/* student overlay */}
            <img
              src="/student-portrait.png"
              alt="A confident learner holding a laptop"
              className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[440px] w-auto object-contain object-bottom select-none pointer-events-none"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
